// extracted by mini-css-extract-plugin
export default {"bubble":"LoadingSpinner_bubble__mUQ-w","dots":"LoadingSpinner_dots__E6yYq","dot":"LoadingSpinner_dot__2ZsXY","bounce":"LoadingSpinner_bounce__pK0SJ"};